var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuperAttemptCoin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4009_2200)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 -0.600098C8.07483 -0.600098 0 7.60938 0 17.6996C0 27.7899 8.07483 36.0002 18.0004 36.0002C27.926 36.0002 36 27.7907 36 17.6996C36 7.60852 27.926 -0.600098 18.0004 -0.600098ZM18.0004 34.9343C8.6533 34.9343 1.04922 27.2035 1.04922 17.6996C1.04922 8.19577 8.6533 0.466617 18.0004 0.466617C27.3475 0.466617 34.9508 8.1975 34.9508 17.6996C34.9508 27.2017 27.3467 34.9343 18.0004 34.9343Z",
    fill: "#C17B16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 -0.0671387C8.3632 -0.0671387 0.52417 7.90261 0.52417 17.6997C0.52417 27.4967 8.3632 35.4673 18.0004 35.4673C27.6376 35.4673 35.4758 27.4967 35.4758 17.6997C35.4758 7.90261 27.6368 -0.0671387 18.0004 -0.0671387Z",
    fill: "url(#paint0_linear_4009_2200)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 4.78339C20.4288 4.78339 22.4382 2.98283 22.8241 0.626915C21.2906 0.178498 19.6739 -0.0664062 18.0005 -0.0664062C16.327 -0.0664062 14.7103 0.178498 13.1768 0.626915C13.5618 2.98369 15.5721 4.78339 18.0005 4.78339Z",
    fill: "url(#paint1_linear_4009_2200)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 30.3801C15.4949 30.3801 13.4338 32.2962 13.1445 34.7643C14.6874 35.2187 16.3151 35.4671 18.0005 35.4671C19.6858 35.4671 21.3135 35.2187 22.8555 34.7643C22.5663 32.2962 20.506 30.3801 18.0005 30.3801Z",
    fill: "url(#paint2_linear_4009_2200)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29443 17.6995C5.29443 15.2315 3.52509 13.1878 1.20697 12.7954C0.765906 14.3545 0.52417 15.9981 0.52417 17.6995C0.52417 19.4009 0.765906 21.0446 1.20697 22.6037C3.52509 22.2113 5.29443 20.1684 5.29443 17.6995Z",
    fill: "url(#paint3_linear_4009_2200)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7046 17.6995C30.7046 20.1684 32.4748 22.2113 34.7929 22.6037C35.234 21.0446 35.4757 19.4009 35.4757 17.6995C35.4757 15.9981 35.234 14.3545 34.7929 12.7954C32.4748 13.1886 30.7046 15.2315 30.7046 17.6995Z",
    fill: "url(#paint4_linear_4009_2200)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9013 8.53201C28.6307 10.2903 31.3297 10.4524 33.2449 9.02958C31.641 6.12521 29.2593 3.72273 26.3864 2.11792C25.0132 4.0625 25.182 6.78404 26.9013 8.53201Z",
    fill: "url(#paint5_linear_4009_2200)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0987 26.6316C7.34039 24.8448 4.58036 24.7043 2.66089 26.2047C4.24278 29.1419 6.61857 31.5763 9.49141 33.2112C10.9953 31.2598 10.8672 28.4296 9.0987 26.6325V26.6316Z",
    fill: "url(#paint6_linear_4009_2200)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93242 8.53113C10.6314 6.80387 10.8163 4.12544 9.49647 2.18604C6.64823 3.80551 4.28854 6.21144 2.70581 9.11408C4.61256 10.4455 7.23772 10.2532 8.93157 8.53113H8.93242Z",
    fill: "url(#paint7_linear_4009_2200)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9014 26.7998C25.1676 28.5616 25.0116 31.3141 26.4213 33.2622C29.2941 31.6487 31.6742 29.2368 33.2722 26.3221C31.3552 24.8776 28.6385 25.0329 26.9014 26.7998Z",
    fill: "url(#paint8_linear_4009_2200)"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 1.18659C27.4697 1.18659 35.1976 8.88298 35.4631 18.4463C35.4673 18.2773 35.4758 18.11 35.4758 17.9401C35.4758 8.14222 27.6368 0.17334 18.0004 0.17334C8.36405 0.17334 0.52417 8.14222 0.52417 17.9401C0.52417 18.11 0.531804 18.2782 0.536893 18.4463C0.802378 8.88298 8.53114 1.18659 18.0004 1.18659Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.63
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 34.347C8.54824 34.347 0.830497 26.6774 0.538718 17.1399C0.53278 17.3262 0.525146 17.5116 0.525146 17.6996C0.525146 27.4966 8.36418 35.4672 18.0014 35.4672C27.6386 35.4672 35.4768 27.4966 35.4768 17.6996C35.4768 17.5116 35.4683 17.3262 35.4632 17.1399C35.1706 26.6782 27.4537 34.347 18.0014 34.347H18.0005Z",
    fill: "#C17B16"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 5.53979C11.4049 5.53979 6.04004 10.9967 6.04004 17.7005C6.04004 24.4043 11.4057 29.8612 18.0005 29.8612C24.5952 29.8612 29.9609 24.4052 29.9609 17.7005C29.9609 10.9958 24.596 5.53979 18.0005 5.53979Z",
    fill: "url(#paint9_linear_4009_2200)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 29.9336C11.5227 29.9336 6.2316 24.6707 6.045 18.1299C6.04161 18.2489 6.03906 18.3679 6.03906 18.4869C6.03906 25.1924 11.4048 30.6476 17.9995 30.6476C24.5942 30.6476 29.9599 25.1916 29.9599 18.4869C29.9599 18.367 29.9574 18.248 29.954 18.1299C29.7674 24.6707 24.4763 29.9336 17.9995 29.9336H18.0003Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6612 9.62896C16.1837 8.98048 16.9785 7.31358 16.6112 5.73291C15.5332 5.8614 14.456 6.13994 13.4067 6.58749C12.3575 7.03504 11.4067 7.62057 10.561 8.31131C11.4126 9.68674 13.1387 10.2783 14.6612 9.62896Z",
    fill: "url(#paint10_linear_4009_2200)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2812 25.6813C19.7095 26.3513 18.9139 28.1036 19.3702 29.7291C20.4551 29.6015 21.5408 29.3221 22.5968 28.872C23.6536 28.4218 24.6095 27.8303 25.4603 27.1335C24.6409 25.6632 22.8529 25.0121 21.2812 25.6822V25.6813Z",
    fill: "url(#paint11_linear_4009_2200)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0335 21.1256C9.39561 19.5785 7.75774 18.7688 6.20215 19.1431C6.32853 20.2391 6.6025 21.3343 7.04271 22.401C7.48292 23.4686 8.0597 24.4344 8.7391 25.2941C10.0911 24.4275 10.673 22.6743 10.0343 21.1256H10.0335Z",
    fill: "url(#paint12_linear_4009_2200)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9692 14.332C26.6079 15.8808 28.2458 16.6888 29.8014 16.3154C29.6741 15.2193 29.4002 14.1242 28.9608 13.0575C28.5206 11.9907 27.9438 11.0241 27.2636 10.1643C25.9115 11.0301 25.3297 12.785 25.9684 14.3329L25.9692 14.332Z",
    fill: "url(#paint13_linear_4009_2200)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2127 9.60042C22.7521 10.2411 24.4867 9.62111 25.3196 8.21636C23.5622 6.82368 21.4476 5.95358 19.2313 5.71558C18.8725 7.30228 19.6825 8.96401 21.2127 9.60042Z",
    fill: "url(#paint14_linear_4009_2200)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.729 25.7106C13.1641 25.0595 11.3973 25.7106 10.5813 27.1636C12.3328 28.583 14.4525 29.4738 16.6764 29.7317C17.1141 28.1062 16.3024 26.3651 14.729 25.7115V25.7106Z",
    fill: "url(#paint15_linear_4009_2200)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9443 14.4036C10.5626 12.866 9.98671 11.137 8.65674 10.2729C7.28945 12.0511 6.43192 14.1897 6.19019 16.4335C7.73051 16.7586 9.32682 15.9359 9.9443 14.4036Z",
    fill: "url(#paint16_linear_4009_2200)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.938 21.0566C25.3069 22.6243 25.9202 24.3921 27.3078 25.2381C28.6921 23.4582 29.5607 21.3093 29.8092 19.0542C28.2332 18.661 26.5708 19.4837 25.938 21.0566Z",
    fill: "url(#paint17_linear_4009_2200)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0158 7.37061C12.4134 7.37061 7.85693 12.0048 7.85693 17.6997C7.85693 23.3946 12.4143 28.0288 18.0158 28.0288C23.6173 28.0288 28.1746 23.3955 28.1746 17.6997C28.1746 12.004 23.6173 7.37061 18.0158 7.37061Z",
    fill: "url(#paint18_linear_4009_2200)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.63
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0929 28.0194C12.6255 28.0194 8.15376 23.605 7.94256 18.0981C7.93747 18.2335 7.93408 18.3689 7.93408 18.506C7.93408 24.2018 12.4914 28.8351 18.0929 28.8351C23.6944 28.8351 28.2518 24.2018 28.2518 18.506C28.2518 18.3698 28.2484 18.2335 28.2433 18.0981C28.0321 23.605 23.5604 28.0194 18.0929 28.0194Z",
    fill: "#C17B16"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0159 7.90526C23.5292 7.90526 28.0272 12.3955 28.1688 17.9662C28.1705 17.8774 28.1756 17.7894 28.1756 17.6997C28.1756 12.0048 23.6182 7.37061 18.0168 7.37061C12.4153 7.37061 7.85791 12.0048 7.85791 17.6997C7.85791 17.7894 7.86215 17.8791 7.8647 17.9688C8.00465 12.3972 12.5026 7.90612 18.0168 7.90612L18.0159 7.90526Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.63
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 6.27106C24.4747 6.27106 29.7599 11.5305 29.9515 18.0661C29.9549 17.9446 29.9609 17.823 29.9609 17.7005C29.9609 10.9967 24.596 5.53979 18.0005 5.53979C11.4049 5.53979 6.04004 10.9967 6.04004 17.7005C6.04004 17.823 6.04513 17.9446 6.04937 18.0661C6.24021 11.5305 11.5262 6.27106 18.0005 6.27106Z",
    fill: "#C17B16"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.041 22.2585H13.1326L13.1318 22.2578L13.041 22.2585Z",
    fill: "url(#paint19_linear_4009_2200)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8037 22.2585H22.8953L22.8046 22.2578L22.8037 22.2585Z",
    fill: "url(#paint20_linear_4009_2200)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9375 24.4421H22.3966L22.841 22.7864H13.4939L13.9375 24.4421Z",
    fill: "url(#paint21_linear_4009_2200)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9275 14.7804C25.9275 14.1639 25.4356 13.6637 24.8291 13.6637C24.2227 13.6637 23.7307 14.1639 23.7307 14.7804C23.7307 15.1029 23.8656 15.3927 24.081 15.5962C23.9877 15.6833 23.8876 15.7825 23.7774 15.8972C22.5254 17.201 20.7569 19.3431 20.7569 19.3431C20.7569 19.3431 19.1768 16.6983 18.5508 15.7954C18.9299 15.6195 19.1937 15.2314 19.1937 14.7796C19.1937 14.163 18.7018 13.6628 18.0953 13.6628C17.4888 13.6628 16.9969 14.163 16.9969 14.7796C16.9969 15.2452 17.2768 15.6436 17.6746 15.8118C17.041 16.7293 15.4795 19.3431 15.4795 19.3431C15.4795 19.3431 13.7101 17.201 12.459 15.8972C12.3403 15.773 12.2317 15.6669 12.1325 15.5746C12.3344 15.372 12.459 15.0909 12.459 14.7804C12.459 14.1639 11.9671 13.6637 11.3606 13.6637C10.7542 13.6637 10.2622 14.1639 10.2622 14.7804C10.2622 15.397 10.7313 15.8722 11.3182 15.8954L13.2835 22.1897H22.9563L24.9224 15.8929C25.4873 15.8463 25.9309 15.3668 25.9309 14.7804H25.9275Z",
    fill: "url(#paint22_linear_4009_2200)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72126 2.7957L8.67883 -2.3999L10.058 2.49474L17.1981 0.565685L10.2836 2.83278L11.7883 9.791L9.76452 3.22859L2.51074 4.49019L9.72126 2.7957Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92482 2.58603L11.8154 -0.321777L10.2191 2.60501L14.4194 5.08251L10.1691 2.86888L7.68812 6.81409L9.74669 2.80679L5.79834 -0.0346181L9.92482 2.58603Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7195 1.52719C12.4914 2.4223 12.4049 3.78394 11.5244 4.56953C10.6449 5.35512 9.3047 5.2663 8.53284 4.37119C7.76014 3.47608 7.8475 2.11445 8.72708 1.32972C9.60751 0.544124 10.9468 0.632945 11.7195 1.52719Z",
    fill: "url(#paint23_radial_4009_2200)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4009_2200",
    x1: 18.2981,
    y1: 1.52215,
    x2: 17.6844,
    y2: 33.6871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7ED43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F7C843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F1BC3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E7AA30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E19F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E09C28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4009_2200",
    x1: 13.1768,
    y1: 2.35849,
    x2: 22.8241,
    y2: 2.35849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4009_2200",
    x1: 13.1445,
    y1: 32.9232,
    x2: 22.8555,
    y2: 32.9232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4009_2200",
    x1: 0.52417,
    y1: 17.6995,
    x2: 5.29443,
    y2: 17.6995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4009_2200",
    x1: 30.7046,
    y1: 17.6995,
    x2: 35.4757,
    y2: 17.6995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4009_2200",
    x1: 25.4704,
    y1: 6.05192,
    x2: 33.2449,
    y2: 6.05192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4009_2200",
    x1: 2.66089,
    y1: 29.1936,
    x2: 10.5296,
    y2: 29.1936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4009_2200",
    x1: 2.70666,
    y1: 6.08554,
    x2: 10.3642,
    y2: 6.08554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4009_2200",
    x1: 25.4704,
    y1: 29.3032,
    x2: 33.2722,
    y2: 29.3032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4009_2200",
    x1: 18.0005,
    y1: 5.0612,
    x2: 18.0005,
    y2: 34.5532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E07828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB43A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4009_2200",
    x1: 10.561,
    y1: 7.81288,
    x2: 16.7003,
    y2: 7.81288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4009_2200",
    x1: 19.2421,
    y1: 27.5733,
    x2: 25.4603,
    y2: 27.5733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4009_2200",
    x1: 6.2013,
    y1: 22.1733,
    x2: 10.293,
    y2: 22.1733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4009_2200",
    x1: 25.7097,
    y1: 13.2851,
    x2: 29.8014,
    y2: 13.2851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4009_2200",
    x1: 19.1473,
    y1: 7.78433,
    x2: 25.3196,
    y2: 7.78433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4009_2200",
    x1: 10.5813,
    y1: 27.5948,
    x2: 16.7952,
    y2: 27.5948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4009_2200",
    x1: 6.19019,
    y1: 13.3886,
    x2: 10.1928,
    y2: 13.3886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4009_2200",
    x1: 25.6895,
    y1: 22.0974,
    x2: 29.8092,
    y2: 22.0974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4009_2200",
    x1: 18.0158,
    y1: 5.06126,
    x2: 18.0158,
    y2: 34.5533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E07828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB43A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4009_2200",
    x1: 13.041,
    y1: 22.2578,
    x2: 13.1326,
    y2: 22.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7ED43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F7C843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F1BC3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E7AA30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E19F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E09C28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4009_2200",
    x1: 22.8037,
    y1: 22.2578,
    x2: 22.8953,
    y2: 22.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7ED43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F7C843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F1BC3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E7AA30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E19F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E09C28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4009_2200",
    x1: 13.4939,
    y1: 23.6142,
    x2: 22.841,
    y2: 23.6142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4009_2200",
    x1: 10.2588,
    y1: 17.9263,
    x2: 25.9275,
    y2: 17.9263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_4009_2200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1249 2.94795) rotate(-41.7503) scale(2.13595 2.14024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4009_2200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperAttemptCoin);
export default __webpack_public_path__ + "static/media/super-attempt-coin.831380ff7dee282e5489f840c582db0a.svg";
export { ForwardRef as ReactComponent };